// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/checkmark_white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapping-view {
  height: calc(100% - 108px);
}
.mapping-view__wrapper {
  height: calc(100% - 108px);
  overflow: auto;
}
.mapping-view__grid {
  display: grid;
  padding: 50px 200px 30px;
  justify-items: stretch;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.mapping-view__grid-header {
  height: 32px;
  border-bottom: 1px solid #E8E9F0;
}
.mapping-view__grid-checkbox {
  -ms-flex-item-align: center;
      align-self: center;
}
.mapping-view__grid-element {
  height: 15px;
  padding: 15px 12px;
  border-bottom: 1px solid #E8E9F0;
  font-size: 12px;
  color: #26282F;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.mapping-view__errors {
  margin: 15px 0;
  color: #F7DDD9;
  line-height: 24px;
  font-size: 16px;
  text-align: center;
}
.mapping-view .SelectInput.Controlled.Input {
  margin: 0;
}
.mapping-view .SelectInput .option {
  cursor: pointer;
}
.mapping-view .CheckBox.Controlled.Input {
  margin: 0;
}
.mapping-view .CheckBox span.Label {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: calc(100% - 24px) !important;
  overflow: visible;
  color: #002E33;
  font-weight: 500;
  line-height: 30px;
}
.mapping-view .CheckBox .check {
  border-radius: 2px;
}
.mapping-view .CheckBox .check.checked {
  border: 1px solid #002E33;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 8px 6px;
  height: 12px;
  width: 12px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/Screen/ImportScreen/MappingView/MappingView.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACC,0BAAA;AADD;AAGC;EACC,0BAAA;EACA,cAAA;AADF;AAIC;EACC,aAAA;EACE,wBAAA;EACF,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AAFF;AAKC;EACC,YAAA;EACA,gCAAA;AAHF;AAMC;EACC,2BAAA;MAAA,kBAAA;AAJF;AAOC;EACC,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,cCqBQ;EDpBR,uBAAA;EACE,gBAAA;EACA,mBAAA;AALJ;AAQC;EACC,cAAA;EACA,cCSM;EDRN,iBAAA;EACE,eAAA;EACF,kBAAA;AANF;AAUE;EACC,SAAA;AARH;AAWE;EACC,eAAA;AATH;AAeE;EACC,SAAA;AAbH;AAgBE;EACC,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,mCAAA;EACA,iBAAA;EACA,cC/DY;EDgEZ,gBAAA;EACA,iBAAA;AAdH;AAiBE;EACC,kBAAA;AAfH;AAiBG;EACC,yBAAA;EACA,oEAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;AAfJ","sourcesContent":["@import \"/src/client/Global/Colors\";\n\n.mapping-view {\n\theight: calc(100% - 108px);\n\n\t&__wrapper {\n\t\theight: calc(100% - 108px);\n\t\toverflow: auto;\n\t}\n\n\t&__grid {\n\t\tdisplay: grid;\n    padding: 50px 200px 30px;\n\t\tjustify-items: stretch;\n\t\talign-items: center;\n  }\n\n\t&__grid-header {\n\t\theight: 32px;\n\t\tborder-bottom: 1px solid $Gray30;\n\t}\n\n\t&__grid-checkbox {\n\t\talign-self: center;\n\t}\n\n\t&__grid-element {\n\t\theight: 15px;\n\t\tpadding: 15px 12px;\n\t\tborder-bottom: 1px solid $Gray30;\n\t\tfont-size: 12px;\n\t\tcolor: $Gray200;\n\t\ttext-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n\t}\n\n\t&__errors {\n\t\tmargin: 15px 0;\n\t\tcolor: $Red10;\n\t\tline-height: 24px;\n    font-size: 16px;\n\t\ttext-align: center;\n\t}\n\n\t.SelectInput {\n\t\t&.Controlled.Input {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t.option {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t.CheckBox {\n\n\t\t&.Controlled.Input {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\tspan.Label {\n\t\t\tdisplay: inline-flex;\n\t\t\twidth: calc(100% - 24px) !important;\n\t\t\toverflow: visible;\n\t\t\tcolor: $DeepSeaGreen;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 30px;\n\t\t}\n\n\t\t.check {\n\t\t\tborder-radius: 2px;\n\n\t\t\t&.checked {\n\t\t\t\tborder: 1px solid $DeepSeaGreen;\n\t\t\t\tbackground: url('~images/checkmark_white.svg') no-repeat center;\n\t\t\t\tbackground-size: 8px 6px;\n\t\t\t\theight: 12px;\n\t\t\t\twidth: 12px;\n\n\t\t\t}\n\t\t}\n\t}\n\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
